// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"index-module--video-container--3P0Y5"};